/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewContractAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Loading from './Loading/index'
import MissingPayors from './MissingPayors/index'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ViewContractAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/ViewContractAction",
  onSubmit,
  isSubmitting
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let generateContractSubmitData = fromData.useDataSubmit({ viewPath,
context: 'generate_contract',
})
let generateContractIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'generate_contract',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="ViewContractAction.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-Z1gWKjf': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="small"
 data="generate_contract"
 onClick={generateContractSubmitData}
 disabled={generateContractIsSubmittingData}
 text="Preview Contract"
/>
<Tysiav2Launch
  viewPath={`${viewPath}/Tysiav2Launch`}
 marginLeft={dtSpaceXs}
 marginBottom={dtSpaceXxxs}
 flexShrink={0}
 width={16}
 height={16}
 stroke={dtColorsNeutral500}
/>
</div>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<MissingPayors
  viewPath={`${viewPath}/MissingPayors`}
/>
{children}
</React.Fragment>)
}